import { CommonModule } from '@angular/common';
import { Component, input, TemplateRef } from '@angular/core';
import { HxLabel } from '../../label/label';

/**
 * Table section component
 *
 * Usage: <hx-table-section label="1. Self-Care Activities"> <hx-table-row>...</hx-table-row>
 * <hx-table-row>...</hx-table-row> </hx-table-section>
 *
 * Or with custom template: <hx-table-section [labelTemplate]="customLabelTemplate"> <hx-table-row>...</hx-table-row>
 * </hx-table-section>
 *
 * Template context: { $implicit: string | null, index: number }
 */
@Component({
  selector: 'hx-table-section',
  standalone: true,
  imports: [CommonModule, HxLabel],
  templateUrl: './table-section.html',
  styleUrls: ['./table-section.css'],
  host: {
    class: 'hx-table-section',
  },
})
export class HxTableSectionComponent {
  /** Section label text */
  readonly label = input<string | null>(null);

  /** Custom template for rendering the label */
  readonly labelTemplate = input<TemplateRef<{ $implicit: string | null; index?: number }> | null>(null);

  /** Section index for template context */
  readonly sectionIndex = input<number>(0);

  /** Label color */
  readonly labelColor = input<string | undefined>(undefined);
}
